import React from 'react';
import {PropTypes} from 'prop-types';
import colors from '../../../constants/colors';
import { XIcon, CheckIcon } from '@forwardfinancing/component-library';

class StatusIndicator extends React.Component {
  render() {
    return(
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 50 50"
      >
        <circle
          fill={this.props.error ? colors.red : colors.green}
          cx="25"
          cy="25"
          r="25"
        />
      { this.props.error ? <XIcon /> : <CheckIcon /> }
      </svg>
    );
  }
}

StatusIndicator.propTypes = {
  error: PropTypes.bool
};

export default StatusIndicator;
